(function () {
  "use strict";

  /* ---- marquee: duplicate content for a seamless loop ---- */
  document.querySelectorAll("[data-marquee-list]").forEach(function (mq) {
    mq.innerHTML += mq.innerHTML;
  });

  /* ---- countdown (announcement bar) — resets on a rolling 24h window ---- */
  var cdEl = document.querySelector("[data-countdown]");
  if (cdEl) {
    var tick = function () {
      var msLeft = 86400000 - (Date.now() % 86400000);
      var h = String(Math.floor(msLeft / 3600000)).padStart(2, "0");
      var m = String(Math.floor((msLeft % 3600000) / 60000)).padStart(2, "0");
      var s = String(Math.floor((msLeft % 60000) / 1000)).padStart(2, "0");
      cdEl.textContent = h + ":" + m + ":" + s;
    };
    tick();
    setInterval(tick, 1000);
  }

  /* ---- product form: variant selection + add to cart ---- */
  var form = document.querySelector("[data-product-form]");
  if (form) {
    var variantsScript = document.querySelector("[data-product-variants]");
    var variants = variantsScript ? JSON.parse(variantsScript.textContent) : [];
    var variantInput = form.querySelector("[data-variant-id-input]");
    var addBtn = form.querySelector("[data-add-to-cart]");
    var atcLabel = addBtn ? addBtn.querySelector("[data-atc-label]") : null;
    var selectors = Array.prototype.slice.call(document.querySelectorAll(".option-selector"));

    var selected = {};
    selectors.forEach(function (sel) {
      var pressed = sel.querySelector('[aria-pressed="true"]');
      selected[sel.dataset.optionPosition] = pressed ? pressed.dataset.value : null;
    });

    /* ---- image gallery: several photos per color (flat shot + on-model shots), cycled
       with prev/next arrows. Photos are grouped by matching each one's ALT TEXT (set in
       Shopify Admin) against the currently selected option value — e.g. every photo whose
       alt text contains "Obsidian" is shown together when that color is selected. No app
       or metafield needed. If nothing matches, we fall back to the variant's single photo
       and hide the arrows. */
    var galleryCard = document.querySelector("[data-gallery-card]");
    var imagesScript = document.querySelector("[data-product-images]");
    var allGalleryImages = [];
    var galleryImg = galleryCard ? galleryCard.querySelector("[data-hero-image]") : null;
    var galleryPrev = galleryCard ? galleryCard.querySelector("[data-gallery-prev]") : null;
    var galleryNext = galleryCard ? galleryCard.querySelector("[data-gallery-next]") : null;
    var galleryDots = galleryCard ? galleryCard.querySelector("[data-gallery-dots]") : null;
    var gallerySet = [];
    var galleryIndex = 0;

    if (imagesScript) {
      try { allGalleryImages = JSON.parse(imagesScript.textContent) || []; } catch (e) { allGalleryImages = []; }
    }

    function normText(s) {
      return (s || "").toString().trim().toLowerCase();
    }

    function renderGalleryDots() {
      if (!galleryDots) return;
      galleryDots.innerHTML = "";
      gallerySet.forEach(function (_, i) {
        var dot = document.createElement("span");
        dot.className = "gallerydot" + (i === galleryIndex ? " is-active" : "");
        galleryDots.appendChild(dot);
      });
    }

    function showGalleryIndex(i) {
      if (!gallerySet.length || !galleryImg) return;
      galleryIndex = (i + gallerySet.length) % gallerySet.length;
      var entry = gallerySet[galleryIndex];
      galleryImg.src = entry.src;
      galleryImg.srcset = entry.src_450 + " 450w, " + entry.src + " 900w";
      galleryImg.alt = entry.alt || "";
      renderGalleryDots();
    }

    function setGalleryForValues(values, fallbackImage) {
      if (!allGalleryImages.length) return;
      /* Only ever group photos by the COLOR option's value — never by size (a size like
         "S" or "M" is short enough to accidentally appear inside unrelated alt text) —
         and only when that value is a real word, not a one/two-letter fragment. */
      var matched = [];
      for (var i = 0; i < values.length && !matched.length; i++) {
        var needle = normText(values[i]);
        if (!needle || needle.length < 3) continue;
        matched = allGalleryImages.filter(function (im) {
          return im.alt && normText(im.alt).indexOf(needle) !== -1;
        });
      }
      if (matched.length) {
        gallerySet = matched;
      } else if (fallbackImage && fallbackImage.src) {
        /* no photo is tagged with this color's name — fall back to THIS variant's own
           photo (never the previously displayed one) so the image always matches the
           selected color even without alt-text tagging. */
        gallerySet = [{ src: fallbackImage.src, src_450: fallbackImage.src, alt: fallbackImage.alt || "" }];
      } else if (galleryImg) {
        gallerySet = [{ src: galleryImg.src, src_450: galleryImg.src, alt: galleryImg.alt }];
      } else {
        gallerySet = [];
      }
      galleryIndex = 0;
      var multi = gallerySet.length > 1;
      if (galleryPrev) galleryPrev.hidden = !multi;
      if (galleryNext) galleryNext.hidden = !multi;
      if (galleryDots) galleryDots.hidden = !multi;
      showGalleryIndex(0);
    }

    function colorSelectorValues() {
      /* Prefer the option actually named "Kolor"/"Color" — falls back to every option's
         value only if the product has none named that way, so grouping never keys off
         an unrelated option like size. */
      var colorVals = selectors
        .filter(function (sel) {
          var name = sel.dataset.optionName || "";
          return name.indexOf("kolor") !== -1 || name.indexOf("color") !== -1 || name.indexOf("colour") !== -1;
        })
        .map(function (sel) { return selected[sel.dataset.optionPosition]; });
      return colorVals.length ? colorVals : selectors.map(function (sel) { return selected[sel.dataset.optionPosition]; });
    }

    if (galleryPrev) galleryPrev.addEventListener("click", function () { showGalleryIndex(galleryIndex - 1); });
    if (galleryNext) galleryNext.addEventListener("click", function () { showGalleryIndex(galleryIndex + 1); });
    if (allGalleryImages.length) {
      var initialMatch = findMatch();
      setGalleryForValues(colorSelectorValues(), initialMatch ? initialMatch.featured_image : null);
    }

    function moneyFormat(cents) {
      // Falls back to a simple format; the page already renders server-formatted money on load.
      return (cents / 100).toFixed(2);
    }

    function findMatch() {
      return variants.filter(function (v) {
        return selectors.every(function (sel) {
          var pos = sel.dataset.optionPosition;
          var want = selected[pos];
          if (!want) return true;
          return v["option" + pos] === want;
        });
      })[0];
    }

    function syncUI() {
      var match = findMatch();
      selectors.forEach(function (sel) {
        var label = sel.closest(".field").querySelector("[data-opt-label]");
        if (label && selected[sel.dataset.optionPosition]) {
          label.textContent = selected[sel.dataset.optionPosition];
        }
        sel.querySelectorAll(".sizepill").forEach(function (btn) {
          btn.setAttribute("aria-pressed", btn.dataset.value === selected[sel.dataset.optionPosition] ? "true" : "false");
        });
      });

      if (!match) return;
      if (variantInput) variantInput.value = match.id;

      var available = match.available;
      if (addBtn) addBtn.disabled = !available;
      if (atcLabel) {
        atcLabel.textContent = available
          ? "Dodaj do koszyka — " + moneyFormat(match.price) + " zł"
          : "Niedostępny";
      }

      var stickyPrice = document.querySelector("[data-sticky-price]");
      if (stickyPrice) stickyPrice.textContent = moneyFormat(match.price) + " zł";
      var stickyAdd = document.querySelector("[data-sticky-add]");
      if (stickyAdd) stickyAdd.disabled = !available;

      /* swap the product photo (and its gallery group) when the chosen variant changes */
      if (allGalleryImages.length) {
        setGalleryForValues(colorSelectorValues(), match.featured_image);
      } else if (match.featured_image && match.featured_image.src) {
        var heroImg = document.querySelector("[data-hero-image]");
        if (heroImg) {
          heroImg.src = match.featured_image.src;
          heroImg.srcset = "";
        }
      }
      if (match.featured_image && match.featured_image.src) {
        var stickyImg = document.querySelector("[data-sticky-image]");
        if (stickyImg) stickyImg.src = match.featured_image.src;
      }
    }

    selectors.forEach(function (sel) {
      sel.addEventListener("click", function (e) {
        var btn = e.target.closest(".sizepill");
        if (!btn || btn.disabled) return;
        selected[sel.dataset.optionPosition] = btn.dataset.value;
        syncUI();
      });
    });

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      if (addBtn && addBtn.disabled) return;

      var formData = new FormData(form);
      if (atcLabel) atcLabel.textContent = "Dodawanie…";

      fetch("/cart/add.js", {
        method: "POST",
        headers: { Accept: "application/json" },
        body: formData
      })
        .then(function (res) {
          if (!res.ok) throw new Error("cart-add-failed");
          return res.json();
        })
        .then(function () {
          if (atcLabel) atcLabel.textContent = "Dodano ✓";
          return fetch("/cart.js").then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          document.querySelectorAll(".cartcount").forEach(function (el) {
            el.textContent = cart.item_count;
          });
          setTimeout(syncUI, 1200);
        })
        .catch(function () {
          // Fall back to a normal (non-AJAX) submit if something goes wrong.
          form.submit();
        });
    });
  }

  /* ---- sticky add-to-cart bar: show once the shopper has scrolled PAST the product
     photo (not merely whenever it's off-screen — on mobile the photo sits below the
     hero text/price/picker, so right after page load it's off-screen-below too, and
     "not intersecting" alone would show the bar immediately). Checking that its
     bottom edge has passed above the viewport top means it only appears once the
     photo is actually behind the shopper, giving a stable color/size reference. */
  var bar = document.querySelector("[data-sticky-bar]");
  var heroMedia = document.querySelector(".heromedia") || document.querySelector(".hero");
  if (bar && heroMedia && "IntersectionObserver" in window) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle("show", entry.boundingClientRect.bottom < 0);
        });
      },
      { threshold: 0 }
    );
    io.observe(heroMedia);
  }
})();
